<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model
        :form="form"
        :model="model"
        :rules="validatorRules"
        @keyup.enter.native="submitForm"
        ref="form"
        slot="detail"
      >
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务商" prop="tenantId">
              <j-dict-select-tag dictCode="sys_tenant,`name`,id" placeholder="请选择服务商" v-model="model.tenantId" />
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投运日期" prop="operationDate">
              <j-date placeholder="请选择投运日期" style="width: 100%" v-model="model.operationDate" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'DeviceServiceForm',
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {
          operationDate: this.$moment().format('YYYY-MM-DD'),
          serviceStatus: 'operation',
          tenantId: 1
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          devName: [{ required: true, message: '请输入设备名称!' }],
        },
        url: {
          edit: '/device/devList/edit',
          editPoints: '/monitor/iotModelPoints/editByCondition',
        },
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify({ ...this.model }))
      // 创建表单实例
      this.form = this.$form.createForm(this)
    },

    methods: {
      edit (record) {
        record.operationDate = this.$moment().format('YYYY-MM-DD')
        this.model = Object.assign(this.modelDefault, record)
        this.visible = true
      },
      submitForm (type) {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl = this.url.add
              method = 'post'
            } else {
              httpurl = this.url.edit
              method = 'put'
            }
            if (type === 'retire') {
              httpurl = this.url.retire
              method = 'post'
            }
            httpAction(httpurl, this.model, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              });


            const editPointDTO = {
              where: {
                dev_id: this.model.id,
              },
              update: {
                tenant_id: this.model.tenantId
              }
            }
            httpAction(this.url.editPoints, editPointDTO, 'put');
          }
        })
      },
    }
  }
</script>
